import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { learningAPI } from '../api/client';
import Breadcrumb from '../components/Breadcrumb';
import { GraduationCap, BookOpen, Clock, Users, Play } from 'lucide-react';

const Learning = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  // Set page title
  useEffect(() => {
    document.title = 'Online Eğitimler | İlkadım360 Hub';
  }, []);

  useEffect(() => {
    loadCourses();
  }, []);

  const loadCourses = async () => {
    try {
      const response = await learningAPI.listCourses();
      setCourses(response.data);
    } catch (error) {
      console.error('Kurslar yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb items={[{ label: 'Online Eğitim', path: null }]} showBackButton={false} />
      
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Online Eğitim</h1>
        <p className="text-gray-600">Öğretmen ve yönetici eğitim kurslarına katılın</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Toplam Kurs</p>
              <p className="text-3xl font-bold text-gray-900">{courses.length}</p>
            </div>
            <div className="p-3 bg-blue-100 rounded-lg">
              <BookOpen className="text-blue-600" size={24} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Kayıtlı Kullanıcı</p>
              <p className="text-3xl font-bold text-gray-900">54</p>
            </div>
            <div className="p-3 bg-green-100 rounded-lg">
              <Users className="text-green-600" size={24} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Tamamlama Oranı</p>
              <p className="text-3xl font-bold text-gray-900">68%</p>
            </div>
            <div className="p-3 bg-purple-100 rounded-lg">
              <GraduationCap className="text-purple-600" size={24} />
            </div>
          </div>
        </div>
      </div>

      {/* Courses Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map((course) => (
          <div key={course.id} className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow overflow-hidden">
            <div className="aspect-video bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
              <GraduationCap className="text-white" size={64} />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                  {course.category}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{course.title}</h3>
              <p className="text-sm text-gray-600 mb-4 line-clamp-2">{course.description}</p>
              
              <div className="space-y-2 mb-4 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <Clock size={16} />
                  <span>
                    {course.duration ? 
                      `${Math.floor(course.duration / 60)} saat ${course.duration % 60} dakika` : 
                      'Süre belirtilmemiş'}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Users size={16} />
                  <span>{course.targetAudience?.join(', ') || 'Herkes'}</span>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-200">
                <button 
                  onClick={() => navigate(`/learning/course/${course.id}`)}
                  className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  <Play size={18} />
                  Kursa Git
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Learning;
